// ── Catálogo de clases en català (puente, Ann 2026-07-15) ────────────────────
// Los NOMBRES de clase vienen de la BD en español (vocabulario CERRADO de
// designaciones: intensidad · tipo · técnico). Ann: «siempre que se marque
// Suave/Estándar (etc.) que se escriba en catalán». Hasta que exista el
// catálogo bilingüe en BD (fase IA traductora del Guardián), este mapa
// traduce SOLO ese vocabulario cerrado al mostrarlo con idioma 'ca'.
// - Solo afecta a la PANTALLA (la BD y las claves CSS siguen en ES).
// - Palabra desconocida (nombres de técnicos, títulos libres) → se deja tal cual.
import i18n from './index';

const MAPA_CA = {
  suave: 'Suau',
  estandar: 'Estàndard',
  paralelo: 'Paral·lel',
  apertura: 'Obertura',
  mixta: 'Mixta',
  meditacion: 'Meditació',
  relajacion: 'Relaxació',
  respiracion: 'Respiració',
  charla: 'Xerrada',
  entrevista: 'Entrevista',
  corporativo: 'Corporatiu',
  testimonio: 'Testimoni',
  testimonios: 'Testimonis',
  vida: 'Vida',
  diaria: 'diària',
  clase: 'classe',
  clases: 'classes',
};

const norm = (w) => w.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Traduce UNA palabra del catálogo respetando su capitalización original.
const palabraCa = (w) => {
  const limpia = w.replace(/[.,;:()]/g, '');
  const ca = MAPA_CA[norm(limpia)];
  if (!ca) return w;
  const conCaso = /^[a-záéíóúñ]/.test(limpia) ? ca.charAt(0).toLowerCase() + ca.slice(1) : ca;
  return w.replace(limpia, conCaso);
};

// Traduce un nombre de clase/designación del catálogo si el idioma es 'ca'.
// «Suave · Paralelo» → «Suau · Paral·lel»; lo que no es catálogo no se toca.
export const catalogoCa = (texto) => {
  if (!texto || typeof texto !== 'string') return texto;
  if ((i18n.language || 'es').slice(0, 2) !== 'ca') return texto;
  return texto.split(' ').map(palabraCa).join(' ');
};

export default catalogoCa;
